module.exports = __webpack_public_path__ + "img/karish_yes.77dc4484.png";